export { default } from "bullitttime-embercomponents/components/ts-tool-tip";
